import { render, staticRenderFns } from "./Flashback.vue?vue&type=template&id=09bcbb3a&"
import script from "./Flashback.vue?vue&type=script&lang=js&"
export * from "./Flashback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports